import { render, staticRenderFns } from "./folderitem.vue?vue&type=template&id=60b8118c"
import script from "./folderitem.vue?vue&type=script&lang=js"
export * from "./folderitem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports